import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsIconComponent } from './icon/icon.component';
import { NotificationActionFilterPipe } from './pipes/action.pipe';
import { NotificationNameFilterPipe } from './pipes/name.pipe';
import { AllNotificationsDialogComponent } from './dialog/all-notifications.component';
import { LayoutModule, MonEventTriggerModule, TableModule } from '@monsido/angular-shared-components';
import { TranslateModule } from '../translate.module';
import { NotificationsRunService } from './run/notifications.service';
import { MomentsModule } from '../moments/moments.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    declarations: [
        NotificationsIconComponent,
        NotificationActionFilterPipe,
        NotificationNameFilterPipe,
        AllNotificationsDialogComponent,
    ],
    imports: [
        CommonModule,
        NgbDropdownModule,
        NgbTooltipMfeModule,
        NgbModalModule,
        LayoutModule,
        TranslateModule,
        TableModule,
        MonEventTriggerModule,
        MomentsModule,
        UpgradePipeModule,
    ],
    exports: [
        NotificationsIconComponent,
    ],
    providers: [
        NotificationsRunService,
        provideAppInitializer(() => {
            const initializerFn = ((notificationsRunService: NotificationsRunService) => {
                return () => notificationsRunService.initializeApp();
            })(inject(NotificationsRunService));
            return initializerFn();
        }),
    ],
})
export class NotificationsModule {}
